import React from 'react';
import { Col, Row } from 'react-bootstrap';

export default function WrapUpPage() {
  return (
    <Row className="margin-topgap40">
      <Col xs={12}>
        <h5
          className="text-center success-response"
          style={{ padding: '20px' }}
        >
          We&apos;ve successfully received your submission and will review it
          shortly.
        </h5>
      </Col>
    </Row>
  );
}
